import Vue from "vue";

// Lib imports
import axios from "axios";
import store from '@/store'
import enviroment from "@/enviroment";

Vue.prototype.$http = axios;

const httpApi = axios.create({ baseURL: enviroment.apiUrl });
const httpTask = axios.create({ baseURL: enviroment.tasksUrl });
const httpAuth = axios.create({ baseURL: enviroment.authUrl });
const httpApps = axios.create({ baseURL: enviroment.appsUrl });
const httpHealthCheck = axios.create({ baseURL: enviroment.healthCheckUrl });
function axiosBase(url) { return axios.create({baseURL: url}) }

httpApi.interceptors.request.use(data => {
    store.commit('loading', true);
  return data
});
httpApi.interceptors.response.use(
  res => {
     store.commit('loading', false);
    return res.data;
  },
  err => {
     store.commit('loading', false);
    console.error(err);
    if (err.response && err.response.status == 401) {
      window.location = enviroment.authUrl;
      return Promise.reject(err);
    } else {
      return Promise.reject(err);
    }
  }
);

httpTask.interceptors.request.use(data => {
    store.commit('loading', true);
  return data
});
httpTask.interceptors.response.use(
  res => {
    store.commit('loading', false);
    return res.data;
  },
  err => {
    store.commit('loading', false);
    console.error(err);
    if (err.response && err.response.status == 401) {
      window.location = enviroment.authUrl;
      return Promise.reject(err);
    } else {
      return Promise.reject(err);
    }
  }
);

httpHealthCheck.interceptors.request.use(data => {
    store.commit('loading', true);
  return data
});
httpHealthCheck.interceptors.response.use(
  res => {
    store.commit('loading', false);
    return res.data;
  },
  err => {
    store.commit('loading', false);
    console.error(err);
    if (err.response && err.response.status == 401) {
      window.location = enviroment.authUrl;
      return Promise.reject(err);
    } else {
      return Promise.reject(err);
    }
  }
);

export default {
  httpApi,
  httpAuth,
  httpApps,
  httpTask,
  httpHealthCheck,
  axiosBase
};
